import axios from "axios";
import endpoint from "./endpoint";
import returnErrorMsg from "../services/handleError";

//     Login   ------->>>>>>>>>>>>
export const login = async (credentails) => {
  try {
    const res = await axios.post(endpoint.login, credentails);

    console.log("RESS ::", res);

    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};

//      LogOut  --- - - -- >>>>>>>>>
export const logout = async (authToken) => {
  let str = authToken.replace(/^"|"$/g, "");
  const AuthStr = "Bearer ".concat(str);

  try {
    const res = await axios.get(endpoint.logout, {
      headers: { Authorization: AuthStr },
    });

    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};

//  Admin Details   - ---- -------->>>>
export const adminDetails = async (authToken) => {
  let str = authToken.replace(/^"|"$/g, "");
  const AuthStr = "Bearer ".concat(str);

  try {
    const res = await axios.get(endpoint.adminDetails, {
      headers: { Authorization: AuthStr },
    });

    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};

// Create Admin -------->>>>>>>
export const createAdmin = async (formData) => {
  try {
    const res = await axios.post(endpoint.createadmin, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    console.log("RESS ::", res);
    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};

// Update Admin -------->>>>>>>
export const updateAdmin = async (formData) => {
  try {
    const res = await axios.patch(endpoint.createadmin, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    console.log("RESS ::", res);
    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};

// Admin Delete  ------>>>>>>>
export const deleteAdmin = async (admin_id) => {
  try {
    const res = await axios.delete(`${endpoint.deleteByid}/${admin_id}`);
    console.log("RESS ::", res);
    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};

// Fetch All Admin   ----------->>>>>>
export const getAllAdmin = async (body) => {
  console.log("ROLEE ::", body);
  try {
    const res = await axios.post(endpoint.allAdmin, body);
    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};

// Acount Profile Statsu   ------------->>>>>>>>>>>
export const account_profile_status = async (data) => {
  try {
    const res = await axios.post(endpoint.account_profile_status, data);
    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};

//////////   -- - - - - - - DRIVER API's - - - - - - - - ///////////////

// All Drivers   ------------->>>>>>>>>>>
export const allDrivers = async () => {
  try {
    const res = await axios.get(endpoint.allDrivers);

    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};

// Get Drivers By Id   ------------->>>>>>>>>>>
export const getDriverById = async (Id) => {
  try {
    const res = await axios.get(`${endpoint.getDriversById}/${Id}`);

    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};

// Add Driver Info -------->>>>>>>
export const addDriver = async (formData) => {
  try {
    const res = await axios.post(endpoint.addDriver, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    console.log("RESS ::", res);
    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};

// Add Car Info  -- ---------->>>>>>>>
export async function addCarInfo(formData) {
  try {
    const response = await axios.post(endpoint.addCarInfo, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    console.log("Save Car Info API Error: ", error.message);

    return returnErrorMsg(error);
  }
}

// Add Car Document ---------->>>>>>>>>>>>
export async function addCarDoc(formData) {
  try {
    const response = await axios.post(endpoint.addCarDoc, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response?.data;
  } catch (error) {
    console.log("Save Car Info API Error: ", error.message);

    return returnErrorMsg(error);
  }
}

// Add Driver Emergency Info --------->>>>>>>>
export async function addEmeregencyInfo(formData) {
  console.log("FRMAFAYAY ::", formData);
  try {
    const response = await axios.post(endpoint.addDriverEmergency, formData);

    return response?.data;
  } catch (error) {
    console.log("Save Driver Info API Error: ", error?.message);

    return returnErrorMsg(error);
  }
}

// Update Driver  -  ------->>>>>>
export const updateDriver = async (formData) => {
  try {
    const res = await axios.patch(endpoint.addDriver, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    console.log("RESS ::", res);
    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};

// Driver Delete  ------>>>>>>>
export const deleteDriver = async (drv_id) => {
  try {
    const res = await axios.delete(`${endpoint.deleteDriver}/${drv_id}`);
    console.log("RESS ::", res);
    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};

// Update Car Info  -- ---------->>>>>>>>
export async function updateCarInfo(formData) {
  try {
    const response = await axios.patch(endpoint.addCarInfo, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    console.log("Save Car Info API Error: ", error.message);

    return returnErrorMsg(error);
  }
}

// Update Car Document ---------->>>>>>>>>>>>
export async function updateCarDoc(formData) {
  try {
    const response = await axios.patch(endpoint.addCarDoc, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response?.data;
  } catch (error) {
    console.log("Save Car Info API Error: ", error.message);

    return returnErrorMsg(error);
  }
}

// Add Driver Emergency Info --------->>>>>>>>
export async function updateEmeregencyInfo(formData) {
  try {
    const response = await axios.patch(endpoint.addDriverEmergency, formData);

    return response?.data;
  } catch (error) {
    console.log("Save Driver Info API Error: ", error?.message);

    return returnErrorMsg(error);
  }
}

// Get Car Info BY Did   ---->>>>>>>>>>>>
export async function getCarInfoByDid(formData) {
  try {
    const res = await axios.get(`${endpoint.carInfo}/${formData}`, formData);

    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
}

// Get Car Document Info BY Did   ---->>>>>>>>>>>>
export async function getCarDocuInfoByDid(formData) {
  try {
    const res = await axios.get(
      `${endpoint.carDocuInfo}/${formData}`,
      formData
    );

    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
}

// Get Driver Emergency Info BY Did   ---->>>>>>>>>>>>
export async function getDriverEmergencyInfoByDid(formData) {
  try {
    const res = await axios.get(
      `${endpoint.driverEmergencyInfo}/${formData}`,
      formData
    );

    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
}

//////////////////  USER OR CUSTOMER API's ///////////    --------->>>>

// All Users   ------------->>>>>>>>>>>
export const allUsers = async () => {
  try {
    const res = await axios.get(endpoint.allUsers);

    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};

// User Login --------------->>>>>>>>>>>>
export async function userLogin(data) {
  console.log("DATAT :", data);
  try {
    console.log("Calling signin user api");
    const response = await axios.post(endpoint.userLogin, data);

    console.log("RESPONSEEE ::", response?.data);
    return response?.data;
  } catch (error) {
    // console.log('Signin API Error: ', JSON.stringify(error.response))
    return returnErrorMsg(error);
  }
}

// User Logouttt ----------->>>>>>>>>>
export async function userLogOut(authToken) {
  const AuthStr = "Bearer ".concat(authToken);

  console.log("Auth ::", AuthStr);

  try {
    const response = await axios.get(endpoint.userLogout, {
      headers: { Authorization: AuthStr },
    });

    return response;
  } catch (error) {
    console.log("Fetch User API Error: ", error.message);
    return returnErrorMsg(error);
  }
}

// Create User ------------>>>>>>>>>>>>>>>
export async function signupUser(data) {
  // console.log('SignUp Data ::', data)
  // console.log('SignUp End Point ::', endpoints.signup)

  try {
    console.log("Calling signup user api");
    const response = await axios.post(endpoint.signUp, data);

    return response?.data;
  } catch (error) {
    // console.log('Signin API Error: ', JSON.stringify(error.response))
    return returnErrorMsg(error);
  }
}

// VeriFy OTP =--------->>>>>>>>>>>>>>
export async function verifyOTP(data) {
  try {
    console.log("Calling Verify OTP API!!!!!!!!!!");
    const response = await axios.post(endpoint.verifyOTP, data);

    return response?.data;
  } catch (error) {
    console.log("Verify OTP API Error: ", error.message);

    return returnErrorMsg(error);
  }
}

// Resend OTPPP -------------->>>>>>>>>>
export async function resendOTP(data) {
  try {
    const response = await axios.post(endpoint.resendOTP, data);

    return response?.data;
  } catch (error) {
    console.log("Verify OTP API Error: ", error.message);

    return returnErrorMsg(error);
  }
}

// Fetch User Details --------->>>>>>>>>>
export async function fetchUser(authToken) {
  const AuthStr = "Bearer ".concat(authToken);

  // console.log('Auth ::', AuthStr)

  try {
    const response = await axios.get(endpoint.userDetails, {
      headers: { Authorization: AuthStr },
    });

    return response?.data;
  } catch (error) {
    console.log("Fetch User API Error: ", error.message);
    return returnErrorMsg(error);
  }
}

// Search Location ------->>>>>>>>>>>>
export async function locationSearch(query) {
  try {
    const res = await axios.get(`${endpoint.searchLocation}/${query}`);
    console.log("RESS ::", res?.data);
    return res?.data?.data;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

////////////////// OTHERRRSSS CUSTOMER API's ///////////    --------->>>>

// ALl States --- --- ------>>>>>>>>>>>>>>
export async function getStates() {
  try {
    const response = await axios.get(endpoint.states);

    return response?.data;
  } catch (error) {
    console.log("Fetch Driver API Error: ", error.message);

    return returnErrorMsg(error);
  }
}

// ALl City ------>>>>>>>>>
export async function getCities(state_id) {
  try {
    const response = await axios.get(`${endpoint.cities}/${state_id}`);
    return response?.data;
  } catch (error) {
    console.log("Fetch Driver API Error: ", error.message);

    return returnErrorMsg(error);
  }
}

// ALl Car Types --- --- ------>>>>>>>>>>>>>>
export async function getCarTypes() {
  try {
    const response = await axios.get(endpoint.carTypes);

    return response?.data;
  } catch (error) {
    console.log("Fetch Driver API Error: ", error.message);

    return returnErrorMsg(error);
  }
}

// ALl Booking --- --- ------>>>>>>>>>>>>>>
export async function getAllBooking() {
  try {
    const response = await axios.get(endpoint.getAllBooking);

    return response?.data;
  } catch (error) {
    console.log("Fetch Driver API Error: ", error.message);

    return returnErrorMsg(error);
  }
}

// ALl Wallet Report --- --- ------>>>>>>>>>>>>>>
export async function getAllWalletReport() {
  try {
    const response = await axios.get(endpoint.getAllWalletReport);

    return response?.data;
  } catch (error) {
    console.log("Fetch Driver API Error: ", error.message);

    return returnErrorMsg(error);
  }
}

// ALl Counts Report --- --- ------>>>>>>>>>>>>>>
export async function getAllCounts() {
  try {
    const response = await axios.get(endpoint.getAllCounts);

    return response?.data;
  } catch (error) {
    console.log("Fetch Driver API Error: ", error.message);

    return returnErrorMsg(error);
  }
}

// ALl Rating & Reviews Report --- --- ------>>>>>>>>>>>>>>
export async function getAllReviews() {
  try {
    const response = await axios.get(endpoint.getAllReviews);

    return response?.data;
  } catch (error) {
    console.log("Fetch Driver API Error: ", error.message);

    return returnErrorMsg(error);
  }
}

// Book Ride  ------------->>>>>>>>>>>>>
export const bookRide = async (formData) => {
  try {
    const res = await axios.post(endpoint.bookRide, formData);
    console.log("RESS ::", res);
    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};

// Send Enquiry  ------------->>>>>>>>>>>>>
export const sendEnquiry = async (formData) => {
  try {
    const res = await axios.post(endpoint.sendEnquiry, formData);
    console.log("RESS ::", res);
    return res?.data;
  } catch (error) {
    return returnErrorMsg(error);
  }
};
